import React from "react";
import { AddBox, Info } from "@material-ui/icons";
import {
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Typography,
  Tooltip,
} from "@material-ui/core";
import { DictionaryConfigData } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      // backgroundColor: "rgba(0,255,0,0.1)",
    },
    titleContainer: {
      display: "flex",
      marginLeft: theme.spacing(1),
    },
    title: {
      fontSize: "0.8rem",
      fontWeight: "bold",
    },
    infoIcon: {
      position: "relative",
      top: -8,
      fontSize: "1rem",
    },
    infoIconButton: {
      position: "relative",
      top: -2,
      marginLeft: "0.25rem",
      width: "1rem",
      height: "1rem",
    },
  })
);

interface Props {
  data: DictionaryConfigData;
  title: string;
  onInfo: () => any;
  onCreate: () => any;
}

// 作成ボタン非活性判定
const isDisabledCreateButton = (data: DictionaryConfigData): boolean => {
  let isDisabled = true;
  if (data.mode === "render" && !data.row) {
    isDisabled = false;
  }
  return isDisabled;
};

/** 辞書設定ペインヘッダー */
export function DictionaryConfigPaneHeader(props: Props) {
  const classes = useStyles();

  const { data, title, onInfo, onCreate } = props;

  //--------------------
  // コンポーネント
  return (
    <div className={classes.header}>
      <div className={classes.titleContainer}>
        {/*
          タイトル表示

        */}
        <Typography component="span" className={classes.title}>
          {title}
        </Typography>

        {/*
          Infoアイコン

        */}
        <div>
          <Tooltip title="説明">
            <IconButton className={classes.infoIconButton} onClick={onInfo}>
              <Info className={classes.infoIcon} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <div>
        {/*
          作成アイコン

        */}
        <span>
          <Tooltip title="作成">
            <span>
              {/*
                ボタンが非活性になるとTooltipが表示できなくなるためspanで囲む必要がある
                Tooltip --- Disabled Elements
                https://material-ui.com/components/tooltips/#disabled-elements
              */}
              <IconButton
                disabled={isDisabledCreateButton(data)}
                onClick={onCreate}
              >
                <AddBox />
              </IconButton>
            </span>
          </Tooltip>
        </span>
      </div>
    </div>
  );
}
